import { BarItemProps } from "@nivo/bar";
import { SUMMARY_REPORT_POPOVER_ID } from "constants/constants";
import { SummaryReportDashboardContext } from "contexts/SummaryReportDashboardContext/SummaryReportDashboardContext";
import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

const SummaryReportCustomBarComponent: FC<BarItemProps<{ [key: string]: string | number }>> = (props) => {
    const {
        selectedDowntimeBar,
        handleSetSelectedDowntimeBar,
        handleSelectedDowntimeBarTitle,
        handleSetSelectedMachineCenterByCode,
    } = useContext(SummaryReportDashboardContext);
    const openSummaryReportPopup = useMemo(() => Boolean(selectedDowntimeBar), [selectedDowntimeBar]);
    const summaryReportPopupId = useMemo(
        () => (openSummaryReportPopup ? SUMMARY_REPORT_POPOVER_ID : undefined),
        [openSummaryReportPopup],
    );
    const { t } = useTranslation();
    return (
        <g
            aria-describedby={summaryReportPopupId}
            transform={`translate(${props.bar.x}, ${props.bar.y})`}
            onClick={(event) => {
                const machineCenterId: number = Number(props.bar.data.data.numberId);
                handleSetSelectedMachineCenterByCode(machineCenterId);
                handleSetSelectedDowntimeBar(event.currentTarget);
                handleSelectedDowntimeBarTitle(
                    t("locations.summary_report_dashboard.downtime_failure_code_by_machine_center.title_modal", {
                        failureCode: props.bar.data.id,
                        machineCenter: props.bar.data.indexValue,
                    }),
                );
            }}
        >
            <rect width={props.bar.width} height={props.bar.height} fill={props.bar.color} />
        </g>
    );
};

export default SummaryReportCustomBarComponent;
